import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS, computed } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Tappable from 'react-tappable';
import Portal from 'react-portal';
import SocialPanel from './SocialPanel';
import { IconArrowHorizontal, IconUpload, IconImageAdd} from './Icons';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import MediaList from './MediaList';
import Settings from './Settings';
import Draggable, {DraggableCore} from 'react-draggable'; // Both at the same time


@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class PicturesBody extends Component {

  @observable imageProgress = false;

  @observable clipartsList = { }
  @observable clipartsListCurrent = { }
  @observable clipartsListCurrentShowBack = false;
 // @observable mediaList = { }


  @observable activeTab = { }

  @observable picturePrevPositionClass = '';
  @observable picturePrevName ='';
  @observable picturePrevShow = false;
  @observable picturePrevImage = null;
  @observable picturePrevStyle = {
    left : '0px',
    top : '0px',
    position: 'absolute',
    zIndex : "100000"
  };
  @observable dragableStyle = {
    left : '0px',
    top : '0px',
    position: 'absolute',
    zIndex : "100000"
  };
  toolBoxHandler = null;
  handlerMain = null;

  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    this.init();

    this.oldJQUERY();
    $('.PicturesBody .iscroll-js').scrollbar();

    session.getSessionFromShop().then((sts)=> {
      //bf_config.session = sts;
      this.bindUploader();
      this.loadMediaImages();
    });

    $(window).on('WorkArea-layer-added',(e,obj)=>{
      setTimeout(()=>{
        this.imageProgress = false;
      },1000);

    });

    $(window).on('SocialGraphic-upload',(e,obj)=>{
      this.uploadFromUrl(obj);
    });

  }

  componentDidMount(){

  }

  loadMediaImages()
  {

    $.ajax({
      // cache: false,
      headers: {
        'x-client-id': bf_config.clientID
      },
      url:  bf_config.api + 'images',
      dataType: "json",
      method : "get",
      success: (data_all)=>
      {
        var data = [];
        for ( var i in data_all )
        {
          if ( data_all[i].type == 'upload' )
          {
            data.push(data_all[i]);
          }
        }

        Settings.setSettingsMediaList(data.reverse());
       // MediaList.set(data.reverse());
        //console.log('this.mediaList',this.mediaList);
        /* DRAG DROP */

        /*
        if ( $(window).width() > 764 )
        {


          $('.js-bf-media li').draggable({
            helper: function() {
              return jQuery(this).clone().appendTo('body').addClass('draggingMedia');
            },
            cursor: 'move',
            containment: "document"
          });

        }
        */

        /* DRAG DROP */


      },
      error:(data)=>
      {

      }
    });
  }


  init(){
    $.ajax({
      // cache: false,
      headers: {
        'x-client-id': bf_config.clientID
      },
      url:  bf_config.api + 'clipart-gallery',
      dataType: "json",
      method : "get",
      success: (data)=>
      {
        this.clipartsList = data;
        this.clipartsListCurrent = _.clone(data);
      },
      error:(data)=>
      {

      }
    });

    this.loadMediaImages();

  }


  removeMediaFromManager(obj)
  {
    this.picturePrevShow = false;
    $.ajax({
      // cache: false,
      headers: {
        'x-client-id': bf_config.clientID
      },
      url:  bf_config.api + 'images/' +obj.id,
      dataType: "json",
      method : "delete",
      success: (data)=>
      {
        $(window).trigger('MediaManager-removeImage',obj);
        this.loadMediaImages();
      },
      error:function(data)
      {

      }
    });

  }

  clickOnPictureElement(img)
  {

    this.imageProgress = true;
    this.addMediaToLayer(img);

  }

  addMediaToLayer(img){

    let objJSON = {
      id : img.id,
      name : img.name,
      path : img.url,
      thumb : img.thumbUrl,
      originalName : img.originalName,
      vector : img.vector,
    };

  //  objJSON = JSON.stringify(objJSON);
    //console.log('img',objJSON);
    $(window).trigger('MediaManager-addLayer', objJSON);

  }

  removeMediaFromLayer(img){

     removeMediaImages(li.attr('data-obj'));
     $(window).trigger('MediaManager-removeImage', $.parseJSON(li.attr('data-obj')));
  }




  pictureMouseEnter(img){

    //console.log('pictureMouseEnter',img);
    this._prevSetPosition(img);
    let path = img.thumbUrl;
    if (img.vector == 'true'  ){
      path = img.path;
    }
    //console.log('path',path);
    this.picturePrevImage = path;
    this.picturePrevName = img.originalName;

    this.picturePrevShow = true;
  }

  _prevSetPosition(img)
  {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    let pos = img.ref.getBoundingClientRect(); // this.toolBoxHandler.getBoundingClientRect();

    let container = $(this.toolBoxHandler);
    let left = pos.left -300;
    let top = pos.top + scrollTop - 70;


    this.picturePrevPositionClass = 'default';

    if ( left < 0 || container.closest('.bf-tools-area').hasClass('wide-mode') || container.closest('.bf-tools-area').hasClass('bf-tools-area-left') ){
      left =  pos.left + img.ref.offsetWidth + 25;
      this.picturePrevPositionClass = 'left';
    }
    else
    {
      left = left + 40;
    }

    //var left = e.clientX - 330;
    //var top = e.clientY -50;

    this.picturePrevStyle = {
      'top': top,
      'left': left,
      'position' : "absolute",
      zIndex : "10000120"
    }
  }



  pictureMouseMove(img){

   this._prevSetPosition(img);


  }

  pictureMouseLeave(){
    this.picturePrevShow = false;

  }


  clickOnClipartList(elem)
  {

    this.clipartsListCurrent = elem.images;
    this.clipartsListCurrentShowBack = true;
  }

  clickOnClipartListBack(){
    this.clipartsListCurrentShowBack = false;
    this.clipartsListCurrent = toJS(this.clipartsList);
  }

  upload(){


    if ( Settings.getSettingsMediaListCount < 1 )
      //if( ($('#bf-media-gallery.js-bf-media:first li').length < 1 ) )
    {
      Settings.setFirstUpload(true,true);

    }
    else
    {
      Settings.setFirstUpload(false);
    }

    if ( Settings.getSettingsFirstUploadAccepted || !Settings.getSettingsFirstUpload )
    {
      if ( Settings.getSettingsMediaListCount > 19 ) {
        var obj = new Object();
        obj.title = "Information";
        obj.text = 'You can have only 20 images in Your media area.';
        obj.type = 'warning';
        $(window).trigger('notify', obj);
      }
      else {

        $(this.handlerMain).find('#bf_filemedia:first input').trigger('click');
        // $('#bf_filemedia:first input').trigger('click');
      }
      $(window).trigger('bodyresize');
    }

  }

    getImageFormUrl(url) {

      let promies = new Promise(async (resolve, reject) => {



      /*
        try {
          abc
          let test = new FileReader();
          var request = new XMLHttpRequest();
          request.open('GET', url, true);
          request.responseType = 'blob';
          request.onload = function() {
            var reader = new FileReader();
            reader.readAsDataURL(request.response);
            reader.onload =  function(e){
              console.log('ok');
            //  console.log('DataURL:', e.target.result);
              resolve(e.target.result);
             // resolve(new Blob([e.target.result], {type: mimeString}));

            };
          };
          request.send();
        }
        catch(e)
        */
        {
        //console.log("catch",e);
          var img = new Image();
          img.setAttribute('crossOrigin', 'anonymous');

          img.onload = function (a) {
            var canvas = document.createElement("canvas");
            canvas.width = this.width;
            canvas.height = this.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(this, 0, 0);

            var dataURI = canvas.toDataURL("image/jpg");

            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
              byteString = atob(dataURI.split(',')[1]);
            else
              byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }


            resolve(new Blob([ia], {type: mimeString}));

          }

          img.onerror = function(){

            reject(null);
          }

          img.src = url;


        }



      });
      return promies;
  }




  async uploadFromUrl(arr){

    let blobImage = null;

    try {
      blobImage = await this.getImageFormUrl(arr.source);
    }
    catch (e){
      console.log('e',e);
      return e;
    }

    //console.log("BLOCB",blobImage);

    let formData = new FormData();
    formData.append('image', blobImage);

      $.ajax({
        // cache: false,
        headers: {
          'x-client-id': bf_config.clientID
        },
        url: bf_config.api + 'images', 
        data : formData,
        method : "post",
        contentType:false,
        processData:false,
        cache:false,
        success: (data)=>
        {
          this.loadMediaImages();
          $(window).trigger('PictureBody-addSocialImage',arr._key);
          return data;
        },
        error:(data)=>
        {

          return data;
        }
      });

  }


  bindUploader()
  {

    $(this.handlerMain).find(".bf-file-uploader-b").uploadFile({
      // url: bf_config.imgs.upload_url,
      headers: {
        'x-client-id': bf_config.clientID
      },
      url: bf_config.api + 'images',
      multiple: true,
      allowedTypes: 'jpg,jpeg,png,svg,eps,ai',
      acceptFiles: 'image/',
      returnType: "json",
      showError: false,
      dragDrop: false,
      fileName: "image",
      beforeSubmit: function (formData, $form, options) {
        if ( Settings.getSettingsMediaListCount < 1 )
        //if( ($('#bf-media-gallery.js-bf-media:first li').length < 1 ) )
        {
          Settings.setFirstUpload(true,true);

        }
        else
        {
          Settings.setFirstUpload(false);
        }
      },
      afterUploadAll: (obj)=> {
        this.loadMediaImages();
        $('.ajax-file-upload-container').css('display', 'none');
        $('.ajax-file-upload-container').html('');
      },
      uploadProgress:  (event, position, total, percentComplete)=> {

      },
      onSubmit:  (files)=> {
        $('.ajax-file-upload-container').css('display', 'block');
      }


    });

  }

  uploadOnClick(e)
  {
    if ( Settings.getSettingsMediaListCount < 1 )
    //if( ($('#bf-media-gallery.js-bf-media:first li').length < 1 ) )
    {
      Settings.setFirstUpload(true,true);
      if ( !Settings.getSettingsFirstUploadAccepted ){
        e.preventDefault();
        e.stopPropagation();
      }
    }
    else
    {
      Settings.setFirstUpload(false);
    }

  }


  render() {

    const trans = this.trans;
    const t = this.t;

    const clipartsList = this.clipartsList;
    const clipartsListCurrent = toJS(this.clipartsListCurrent);
    const mediaList = Settings.getSettingsMediaList;// MediaList.elements;

    if ( $(window).width() > 764 ) {
      $('.js-clipart-element').draggable({
        helper: function () {

          return jQuery(this).clone().appendTo('body').css({
            'zIndex': 5
          });
        },
        cursor: 'move',
        containment: "document"
      });

      $('.js-bf-media li').draggable({
        helper: function () {

          return jQuery(this).clone().appendTo('body').addClass('draggingMedia');
        },
        cursor: 'move',
        containment: "document"
      });
    }

    setTimeout(()=>{
      $('.PicturesBody .iscroll-js').scrollbar();

    },100)


    return (
      <span className="PicturesBody" ref={(main)=> {this.handlerMain = main}}>
        <Portal
          isOpened={ this.picturePrevShow }
        >
            <div style={this.picturePrevStyle} >
              <div className={"PicturesPrev " + this.picturePrevPositionClass} >
                <span className="PicturesPrev-img"
                  style={{'backgroundImage' : 'url('+(  this.picturePrevImage )+')' }}
                ></span>
                <span className="PicturesPrev-title">{this.picturePrevName}</span>
              </div>
            </div>
        </Portal>



        <div className="tools-nav">
          <span className="js-tabs active" data-tab="pictures">{ t('Uploads') }</span>
          <span className="js-tabs" data-tab="cliparts">{ t('Graphic') }</span>
        </div>

        <div className="bf-media-container js-tools-on-off-content" >
          <div className="bf-media-pictures active js-tabs-content" data-tab="pictures">

            {
              ( this.props.withSmallUploadArea && mediaList.length > 0 )
              &&
                <div  onClick={ ()=> { this.upload() } } className="Pictures-smallUploadArea ">
                  {t('Upload images')} <IconUpload />
                </div>
            }


              <div onClick={(e)=>{this.uploadOnClick(e)}} id="bf_filemedia" style={{'display': ( !mediaList || mediaList.length < 1 ? 'block' : 'none' )}} className=" bf-file-uploader-b bf-file-media ">

              </div>
              <div className="bf_filemedia_shadow" style={{'display': (!mediaList || mediaList.length < 1 ? 'flex' : 'none' )}}>
                <span className="bf-file-media-title">
                   <IconImageAdd size="full"/>
                   <span>{ t('Upload') }</span>
                </span>

                <span className="bf-file-media-text">{ t('Drag photos here or click to upload') }</span>
              </div>
            {

             (mediaList && mediaList.length > 0)
             &&
             <div className="Pictures-scrollContainer">
               {
                 this.imageProgress
                 &&
                 <div className="image-progress">
                   <div className="cssload-container">
                     <div className="cssload-speeding-wheel"></div>
                   </div>
                   <span>{t('Adding')}</span></div>
               }

              <div className={"iscroll-js scrollbar-inner "}>

              <ul id="bf-media-gallery" className="js-bf-media bf-file-media">
                {
                  _.map(mediaList, (img, key) => {

                    let objJSON = {
                      id : img.id,
                      name : img.name,
                      path : img.url,
                      thumb : img.thumbUrl,
                      originalName : img.originalName,
                      vector : img.vector,
                    };

                    objJSON = JSON.stringify(objJSON);

                    return (
                      <li
                        ref={(input) => { img.ref = input; }}
                        className="clipart-element js-clipart-element"
                        key={key}
                        onMouseEnter={ ()=> {  this.pictureMouseEnter(img) } }
                        onMouseMove={ ()=> { this.pictureMouseMove(img) } }
                        onMouseLeave={ ()=> { this.pictureMouseLeave(img) } }
                        data-obj={objJSON}
                        >
                         <span>

                              <span
                                className="clipart-element-image"
                                key={key}
                                style={{'backgroundImage' : 'url('+(  (img.vector === true) ? img.url : img.thumbUrl )+')' }}
                              >
                                 <Tappable onTap={ ()=> { this.removeMediaFromManager(img) } }>
                                  <span  className="clipart-element-remove"><span>+</span></span>
                                 </Tappable>
                                <Tappable onTap={ ()=> { this.clickOnPictureElement(img) } }>
                                  <span className="clipart-element-add" ><span>+</span></span>
                                </Tappable>
                              </span>
                              <span className="clipart-element-title">{img.originalName}</span>

                          </span>

                      </li>


                    )
                  })
                }
              </ul>
              </div>

             </div>
            }

          </div>
          <div className="bf-media-clipart js-tabs-content" data-tab="cliparts">
            {
              this.clipartsListCurrentShowBack
              &&
              <div onClick={ ()=> { this.clickOnClipartListBack()} } className="clipart-back">
               <IconArrowHorizontal active={true} size="small"/>  Back
              </div>
            }
            {
              this.imageProgress
              &&
              <div className="image-progress">
                <div className="cssload-container">
                  <div className="cssload-speeding-wheel"></div>
                </div>
                <span>{t('Adding')}</span></div>
            }

            <div className="iscroll-js scrollbar-inner">
              <ul className="bf-cliparts-list js-bf-cliparts-list">
                {
                  _.map(clipartsListCurrent, (cl, key) => {


                    let objJSON = {
                        id : cl.id,
                        name : cl.name,
                        path : cl.url,
                        thumb : cl.thumbUrl,
                        originalName : cl.originalName,
                        vector : cl.vector,
                    }

                    objJSON = JSON.stringify(objJSON);

                    return (

                      <li
                        key={key}
                        data-id={cl.id}
                        className={ !cl.url ? "clipart-category" : "clipart-element js-clipart-element"}
                        data-obj={objJSON}

                      >
                        { !cl.url
                        ?
                          <span  onClick={ ()=> { this.clickOnClipartList(cl) } } >{  t(cl.name) }</span>
                          :
                          <span

                          >

                            <span
                              ref={(input) => { cl.ref = input; }}
                              onMouseEnter={ ()=> {  this.pictureMouseEnter(cl) } }
                              onMouseMove={ ()=> { this.pictureMouseMove(cl) } }
                              onMouseLeave={ ()=> { this.pictureMouseLeave(cl) } }
                              className="clipart-element-image"
                              key={key}
                              style={{'backgroundImage' : 'url('+(  (cl.vector === true) ? cl.url : cl.thumbUrl )+')' }}
                             >
                            <Tappable onTap={ ()=> { this.clickOnPictureElement(cl) } }>
                              <span className="clipart-element-add" ><span>+</span></span>
                            </Tappable>
                            </span>
                            <span className="clipart-element-title">{cl.originalName}</span>

                          </span>

                        }
                      </li>
                    )
                  })
                }
              </ul>
            </div>
          </div>
        </div>
        {
          ( !this.props.withSmallUploadArea || mediaList.length < 1 )
          &&
          <span className="PicturesBody-sep"></span>
        }
        {
          ( !this.props.withSmallUploadArea || mediaList.length < 1 )
            &&
            <SocialPanel
              dictionaryStorage={this.props.dictionaryStorage}
            />
        }
      </span>
    );


  }

  oldJQUERY(){

    let scope = this;

    $(window).on('removeMediaImagesById',function(e,id){
     
      $.ajax({
        // cache: false,
        headers: {
          'x-client-id': bf_config.clientID
        },
        url:  bf_config.api + 'images/' +id,
        dataType: "json",
        method : "delete",
        success: function(data)
        {
          // $(window).trigger('MediaManager-removeImage',obj);

        },
        error:function(data)
        {

        }
      });
    })


    $(document).ready(function(){
      if ( $('#bf-project-site').length > 0 )
      {

      }
    })

  }

}






